export class StreamingAlertsRequestModel {
    public nextId: string | null = null;
    public config = '';
    public noRepeat = false;
    public repeatIntervalInMinutes = -1;
    public saveToMru = false;
}